import Dialog from './components/Dialog'
import Petition from './components/Petition'
import Share from './components/Share'
import Clickify from './components/Clickify'
import Counter from './components/Counter'
import T from './components/T'

import apConfig from "@config/247.json"
if (apConfig.actionpage && apConfig.template && apConfig.template == true) { apConfig.actionpage = null; }
export const config = apConfig
export const steps = {Dialog,Petition,Share}

export const portals = {Clickify,Counter,T}

